/**
 * Created by mauget on 1/20/16.
 */

import contentTemplate  from 'designer/header-view.ejs';
import constants        from 'Constants.js';
import ContextMenuController from 'ContextWorkflowMenuController.js';
import BaseMainView     from 'BaseMainView.js';
import listService      from 'ListService.js';
import { ConnectionArrowClass } from 'shapelib/ConnectionArrowClass.js';
import connectionController     from 'ConnectionController.js';
import util             from 'util/Util';
import quickHelp from 'QuickHelpView';

const SILENT = constants.MODEL_SILENT;

//=============================================================================
//
// Workflow view of PerfectForms Designer. 
// It's a mere clone from the Behavior View already implemented.
//
// - Rene Lopez 06-04-2016
//
//=============================================================================
class WorkflowView extends BaseMainView {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.events = {
        };        
        return this;
    }

    //==========================================================
    // Impose well-known DOM IDs for use by Q/A test automation.
    // JQuery is our friend.
    //==========================================================
    injectTestIds() {

        const selector = '.factory-widget-icon';
        const prefix = 'WFI_';

        super.injectTestIds( selector, prefix );

        const selector2 = '.factory-widget-text';
        const prefix2= 'WFT_';

        super.injectTestIds( selector2, prefix2 );

    }


    initPage() {

        this._contextMenu = new ContextMenuController().menu;

        this.listenTo(this.model, 'change', this.render);

        this.initMenu( constants.KIND_WORKFLOW );
        listService.currentSelectedPathId = undefined;


        this.initWorkflowToolbarPane();
        // /this.initToolbarPane();
        //this.initBehaviorToolboxPane();
        this.initEditorContent( constants.KIND_WORKFLOW );

    }

    renderWorkflowObjects() {

        // This function recovers the connection point coordinates and uses the widgets refed by owners object.
        // Obsolete - used method in UTIL
        function getStageCoordinateInfo(connection) {

            // Note: owners object contains the two fabric.js endpoint widgets created in pass one of the behavior render loop
            const
                srcDotNum  = connection.srcDot,    // Dot number 0 .. 3 is needed connection index - 1
                destDotNum = connection.destDot    // Dot number 0 .. 3 is needed connection index - 1

            const
                cp1 = connection.srcCommand.model.get('widget')._objects[ srcDotNum ],
                cp2 = connection.destCommand.model.get('widget')._objects[ destDotNum ];

            // Set coords from cp1 and cp2.
            const coords = [
                cp1.originalLeft + cp1.radius, cp1.originalTop + cp1.radius,
                cp2.originalLeft + cp2.radius, cp2.originalTop + cp2.radius
            ];

            // console.log(`coords:`, coords);

            // Result is an info object
            const cobj = {
                coords: coords,
                srcDot: srcDotNum, destDot: destDotNum,
                src: connection.srcCommand, dest: connection.destCommand };
            return cobj;
        }


        // Render stages immediately
        const objs = listService.getWorkflowStages();
        objs.map( (view, k) => {
            view.render();
        });

        // Render stages immediately
        const comments = listService.getWorkflowComments();
        comments.map( (view, k) => {
            view.render();
        });


        // Widgets assumed rendered, so connect them:
        const connect = ( fcanvas, processedConnectionIds ) => {
            const c = 2 * constants.CONNECTION_RADIUS; // .. radius of orange dot
            const
                locked = true,
                unlocked = !locked,
                paths = listService.workflowPaths;

            // Draw connection Lines such that they associate to source-dest command connection points.
            // Restrict to getting connections for current instance ID ( matching connection.scriptId )

            paths.map((connection, k) => {

                // If not already processed for other endpoint:
                if (!processedConnectionIds[k]) {
                    processedConnectionIds[k] = true;

                    console.log(`CONNECT: `, connection);

                    //const cinfo = getStageCoordinateInfo(connection);
                    const cinfo =  util.getCommandCoordInfo(connection);
                    const opts = constants.LINE_MODEL_OPTIONS;
                    opts.model = connection.model;
           
                    if (connection.model.attributes.hasConditions === undefined){
                      //false for always
                      connection.model.attributes.hasConditions = false;
                      if (connection.model.attributes.Parameters && connection.model.attributes.Parameters.Parameter && connection.model.attributes.Parameters.Parameter.length > 0){
                        if (!connection.model.attributes.Parameters.Parameter[0].EXPR.EXPR){
                            //true for advanced
                            connection.model.attributes.hasConditions = true;
                        }else if (connection.model.attributes.Parameters.Parameter[0].Expression.arguments[0]){
                            //true for simple (Text or NUmber)
                           connection.model.attributes.hasConditions = true;
                        }
                      }
                    }                    
                    connection.model.attributes.hasNotifications = false;
                    connection.model.attributes.hasScripts = false;

                    // Hack to avoid errors on copy paste of connected workflow
                    connection.model.attributes.srcDot = connection.srcDot;
                    connection.model.attributes.destDot = connection.destDot;

                    const inst = listService.getBehaviorInstanceByObject(opts.model.get('id')).first();


                    if (inst) {
                        const commands = listService.getBehaviorInstanceObjects(inst.get('id'), null);
                        connection.model.attributes.hasScripts = commands.size > 0;
                        commands.map( (behavior, k) => {
                            if (behavior.model.get('factoryKey') === 'command_notify'){
                                connection.model.attributes.hasNotifications = true;
                            }
                        });
                    }

                    // There is a problem when connectors are vertical or horizontal aligned. This hack avoid
                    // disconnections due to same x, y parameters
                    // Same for behaviors on BehaviorHelperService
                    if (cinfo.coords[0] === cinfo.coords[2]) {
                        ++cinfo.coords[2];
                    }
                    if (cinfo.coords[1] === cinfo.coords[3]) {
                        ++cinfo.coords[3];
                    }
                    // A fabric.js shape for rendering
                    const line = new ConnectionArrowClass(cinfo.coords, opts);
                    connection.line = line;

                    // Hold fabric.js line in connection model, created from XML
                    fcanvas.add(line);

                    // Ensure fabric event handler can see the model for property clicks
                    //const model = new LineModel({});
                    line.model = connection.model; // = model;

                    // Stick the line to fabric raw widgets to associate movement sticking
                    const
                        w1 = cinfo.src.model.get('widget'),
                        w2 = cinfo.dest.model.get('widget');

                    line.srcId = w1.model.get('id');
                    line.destId = w2.model.get('id');

                    connectionController.glueLineToEndPoints(w1, w2, line, null);
                }

            });
        };

        console.log(`CONNECTIONS to connect:: `, listService.workflowPaths.toJS());

        // Widgets assumed rendered, so connect them:
        const processedConnectionIds = {};
        connect( listService.fcanvas, processedConnectionIds );
    }



    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));
        this.initPage();
        this.renderWorkflowObjects();

        listService.fcanvas.deactivateAll().renderAll();

        this.injectTestIds();

        util.printHeader(listService.dashboardLayout.mainPanelView.model);
        const quickHelpView = new quickHelp({el:".quick-help-view", type: 'app', helpLink: ""});
        quickHelpView.render();

        this.delegateEvents();
        util.enableSaveOption();
        return this;
    }
    
    removeUnused() {
        this._contextMenu.destroy();
    }
    
    remove() {
        this._contextMenu.destroy();
        super.remove();
    }

}

export default WorkflowView;
